import { createContext, useContext, useEffect, useState, useRef} from "react";
import { useRole } from "../../contexts/RoleContext";

const SseContext = createContext(null);

export const SseProvider = ({ children, API_ENDPOINT }) => {
  const { role } = useRole();
  const [es, setEs] = useState(null);
  const eventSourceRef = useRef(null);

  useEffect(() => {
    if (!role) {
      return;
    }

    if (eventSourceRef.current) {
    //   console.log("SSE connection already active.");
      return;
    }

    // console.log("Starting SSE stream...");
    const eventSource = new EventSource(`${API_ENDPOINT}/api/Updates/Stream`, {
      withCredentials: true,
    });

    eventSourceRef.current = eventSource; 
    setEs(eventSource); 

    eventSource.onerror = (err) => {
      console.error("SSE error:", err);
      eventSource.close();
      eventSourceRef.current = null;
      setEs(null);
    };

    return () => {
      if (eventSourceRef.current) {
        // console.log("Closing SSE connection...");
        eventSourceRef.current.close();
        eventSourceRef.current = null;
        setEs(null);
      }
    };
  }, [API_ENDPOINT, role]);

//   const closeSse = useCallback(() => {
//     if (eventSourceRef.current) {
//       eventSourceRef.current.close();
//       eventSourceRef.current = null;
//       setEs(null);
//       console.log("SSE connection closed manually.");
//     }
//   }, []);

  return (
    <SseContext.Provider value={es}>
      {children}
    </SseContext.Provider>
  );
};

export const useSse = () => useContext(SseContext);
